import { render, staticRenderFns } from "./JourneyBuilderOverviewSankey.vue?vue&type=template&id=85b9d8b6&"
import script from "./JourneyBuilderOverviewSankey.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderOverviewSankey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85b9d8b6')) {
      api.createRecord('85b9d8b6', component.options)
    } else {
      api.reload('85b9d8b6', component.options)
    }
    module.hot.accept("./JourneyBuilderOverviewSankey.vue?vue&type=template&id=85b9d8b6&", function () {
      api.rerender('85b9d8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Overview/JourneyBuilderOverviewSankey.vue"
export default component.exports